var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile",attrs:{"type":"false"}},[_c('headers_m'),_vm._v(" "),_c('div',{staticClass:"mains"},[_c('img',{staticClass:"agenda",attrs:{"src":_vm.$t('magenda').src,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"footer_mobile"},[_vm._v("Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b532cc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/agenda.vue
// module id = null
// module chunks = 